module.exports = __webpack_public_path__ + "static/media/t10.a20b5491.png";